/* eslint-disable no-nested-ternary */
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { bool, number, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSpring } from 'react-spring';

import {
  CardContainer,
  DURATION,
  getCardContentContainerLayoutProps,
} from './TestCard.layoutProps';

const TestCard = ({
  isActive,
  isSkipped,
  questionCount,
  questionNumber,
  text,
  withCornerNumbers,
  zIndex,
}) => {
  const { dynamicWidth, isTabletLG, isTabletSM } = useScreenSize();

  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [isCardVisible, setIsCardVisible] = useState(true);
  const animationProps = useSpring({
    config: { friction: 40, mass: 5, tension: DURATION },
    from: { rotate: 0, x: 0, y: 0 },
    opacity: isCardVisible ? 1 : 0,
    to: async (next) => {
      if (isAnimatingOut && isSkipped && isCardVisible) {
        const direction = Math.random() < 0.5 ? -1 : 1;
        await next({
          rotate: direction * 50,
          x: direction * window.innerWidth * 1.3,
          y: 0,
        });
      }
    },
  });

  useEffect(() => {
    if (!isActive && isSkipped) {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setIsAnimatingOut(false);
      }, DURATION);
    }
  }, [isActive]);

  useEffect(() => {
    if (isSkipped && isCardVisible) {
      setTimeout(() => {
        setIsCardVisible(false);
      }, DURATION);
    }
  }, [isSkipped, isCardVisible]);

  return (
    <CardContainer style={animationProps} zIndex={zIndex}>
      <Flex
        {...getCardContentContainerLayoutProps({
          dynamicWidth,
          isTabletLG,
          withCornerNumbers,
        })}
      >
        {withCornerNumbers && (
          <Typography
            color={theme.colors.white[60]}
            position="absolute"
            right={12}
            top="4px"
            variant="MS-regular-s20-lh31"
          >
            {questionNumber}/{questionCount}
          </Typography>
        )}
        {!withCornerNumbers && (
          <Typography
            color={theme.colors.white[60]}
            variant="MS-regular-s32-lh50"
          >
            #{questionNumber}
          </Typography>
        )}
        <Typography
          color={theme.colors.white[isTabletSM ? 80 : 100]}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
          m="auto"
          variant={isTabletLG ? 'MS-regular-s18-lh22' : 'MS-regular-s20-lh31'}
        />
      </Flex>
    </CardContainer>
  );
};

TestCard.propTypes = {
  isActive: bool,
  isSkipped: bool,
  questionCount: number.isRequired,
  questionNumber: number.isRequired,
  text: string.isRequired,
  withCornerNumbers: bool,
  zIndex: number.isRequired,
};

TestCard.defaultProps = {
  isActive: false,
  isSkipped: false,
  withCornerNumbers: false,
};

export default TestCard;
